import { render, staticRenderFns } from "./PageStyle.vue?vue&type=template&id=1803c266&"
import script from "./PageStyle.vue?vue&type=script&lang=js&"
export * from "./PageStyle.vue?vue&type=script&lang=js&"
import style0 from "./PageStyle.vue?vue&type=style&index=0&id=1803c266&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports